// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';

import getAllBogoSpecialsForCart from './get-all-bogo-specials-for-cart';
import determineRewards from './determine-rewards';
import { mergeSatisfiers } from './common';

// Determine possible BOGO discounts to be applied later. NOTE: bogoCalcsData will be mutated
const determineBogoDiscounts = ({
  bogoCalcsData,
  detailsSorted: items,
  discountTaxOrder,
  medicalOrder,
  globalSpecialsSettings,
}) => {
  if (!bogoCalcsData.allBogoSpecials) {
    // Attach to bogoCalcsData for reruns
    bogoCalcsData.allBogoSpecials = getAllBogoSpecialsForCart(items, medicalOrder, globalSpecialsSettings);
  }

  const { allBogoSpecials } = bogoCalcsData;

  if (allBogoSpecials.length > 0) {
    _.forEach(allBogoSpecials, (bogoSpecial) => {
      /*
        Here we want to group the items by their matching SKU if it is
        required by the offer (LLx). When the SKU is present we only want to qualify products that
        match in SKU, so below we separate the items into an array of arrays that are
        grouped by SKU
       */
      let itemGroups = [items];
      if (bogoSpecial?.requireSingleSKU) {
        itemGroups = _.values(
          _.reduce(
            items,
            (skuGroups, item) => {
              if (!skuGroups[item.cannonicalSKU]) {
                skuGroups[item.cannonicalSKU] = [];
              }
              skuGroups[item.cannonicalSKU].push(item);
              return skuGroups;
            },
            {}
          )
        );
      }
      _.forEach(itemGroups, (itemGroup) => {
        determineRewards(bogoCalcsData, bogoSpecial, discountTaxOrder, itemGroup, globalSpecialsSettings);
      });
    });
    const applicableRewards = {};

    // here we need to merge classic rewards and discount to cart rewards
    const mergedRewards = mergeSatisfiers(bogoCalcsData.rewardsSatisfiers, bogoCalcsData.discountToCartRewards, true);
    _.forEach(mergedRewards, (satisfier, itemKey) => {
      applicableRewards[itemKey] = _.reduce(
        satisfier.rewards,
        (rewards, current) => {
          // SECPO = stacking enabled compounding percent off
          // DTC = discount to cart
          const isSecpoDtc =
            !!current.reward.discountToCart?.enabled &&
            current.discountStacking &&
            current.reward.discountToCart?.discountType === 'percentDiscount' &&
            current.stackingBehavior === 'compounding';
          bogoCalcsData.containsStackingPercentageCompoundingDtc =
            bogoCalcsData.containsStackingPercentageCompoundingDtc || isSecpoDtc;
          rewards.push({
            applicableQuantity: current.quantity,
            conditionQuantity: _.reduce(
              bogoCalcsData.conditionsSatisfiers?.[itemKey]?.conditions || [],
              (quantity, condition) =>
                condition.specialId === current.specialId ? quantity + condition.quantity : quantity,
              0
            ),
            isItemsForAPriceReward: !!current.reward?.isItemsForAPriceReward,
            isDiscountToCartReward: !!current.reward.discountToCart?.enabled,
            ...(current.reward?.dollarDiscount
              ? {
                  dollarDiscount: Big(current.reward.dollarDiscount)
                    .times(current.reward.redemptionMultiplier || 1)
                    .toString(),
                }
              : {}),
            ...(current.reward?.percentDiscount ? { percentDiscount: current.reward.percentDiscount } : {}),
            ...(current.reward?.targetPrice ? { targetPrice: current.reward.targetPrice } : {}),
            ...(isSecpoDtc ? { redemptionMultiplier: current.reward.redemptionMultiplier } : {}),
            isSecpoDtc,
            rewardId: current.reward?._id,
            satisfiedBy: current.satisfiedBy || {},
            specialId: current.specialId,
            specialType: 'bogo',
            stackingMode: current.stackingMode,
            discountStacking: current.discountStacking,
            stackingBehavior: current.stackingBehavior,
          });
          return rewards;
        },
        []
      );
    });

    bogoCalcsData.applicableRewards = applicableRewards;
  }
  bogoCalcsData.redetermineDiscounts = false;

  return bogoCalcsData;
};

export default determineBogoDiscounts;
